module.exports = __webpack_public_path__ + "media/error-web.6cf99e73.png";